import layout from './home/'
export default layout



// WEBPACK FOOTER //
// ./src/layout/index.js